var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgProfile(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.10671 7.24668C8.04004 7.24001 7.96004 7.24001 7.88671 7.24668C6.30004 7.19334 5.04004 5.89334 5.04004 4.29334C5.04004 2.66001 6.36004 1.33334 8.00004 1.33334C9.63337 1.33334 10.96 2.66001 10.96 4.29334C10.9534 5.89334 9.69337 7.19334 8.10671 7.24668Z",
    stroke: "#5A5A5A",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4.77348 9.70666C3.16014 10.7867 3.16014 12.5467 4.77348 13.62C6.60681 14.8467 9.61348 14.8467 11.4468 13.62C13.0601 12.54 13.0601 10.78 11.4468 9.70666C9.62014 8.48666 6.61348 8.48666 4.77348 9.70666Z",
    stroke: "#5A5A5A",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProfile);
export default __webpack_public_path__ + "static/media/profile.2519d52805a494d7d7a5e60612e19e2d.svg";
export { ForwardRef as ReactComponent };